// If this script works, we have javascript enabled so remove the no-js class from the html element.
(function (H) { H.className = H.className.replace(/\bno-js\b/, 'js') })(document.documentElement);